import { Card, CardContent, CardHeader } from '../../../components/Card';
import { Skeleton } from '../../../components/Skeleton';

export function RecentSessionsListSkeleton() {
  return (
    <ul className="flex w-full flex-col gap-4 overflow-auto">
      {Array.from({ length: 3 }).map((_, idx) => (
        <li key={`session-skeleton-${idx}`}>
          <Card className="w-full">
            <CardHeader className="flex flex-row justify-between">
              <Skeleton className="h-12 w-1/6" />
              <Skeleton className="h-12 w-1/2" />
            </CardHeader>
            <CardContent>
              <Skeleton className="h-36 w-full" />
            </CardContent>
          </Card>
        </li>
      ))}
    </ul>
  );
}
